import React from 'react';
import classNames from 'classnames';
import ListItem from '../../platformui/SearchBlock/listitem';

const Related = (props) => {
  if (props.List.Items.length < 1) return false;

  const items = props.List.Items.map((item, index) => {
    const theme = classNames({
      'c-related__item': true,
      'c-related__item--has-image': item.Image,
      [`c-related__item--theme-${item.Theme}`]: true,
    });

    return (
      <li key={index}>
        <ListItem
          key={index}
          className={theme}
          href={item.Url}
          searchHitHeading={item.Text}
          image={item.Image}
          vignette={item.Vignette}
          heading={item.Heading}
        />
      </li>
    );
  });

  return (
    <div className="c-related">
      {props.Heading && <h2 className="c-related__heading">{props.Heading}</h2>}
      <ul className="c-related__question-list">{items}</ul>
    </div>
  );
};

export default Related;
